import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import LogoDark from 'src/assets/images/logo.png';
import LogoWhite from 'src/assets/images/logo-white.png';
import { LightDarkVariant } from 'src/common/models/lightDarkVariant';
import { media } from 'src/config/breakpoints';

export interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  variant?: LightDarkVariant;
  className?: string;
}

const StyledLogo = styled.img`
  height: 2.25rem;

  ${media.w.max.px768(css`
    width: 9.9375rem;
  `)};
`;

export const Logo: FC<LogoProps> = ({ variant, className, style, ...rest }) => (
  <StyledLogo
    src={variant === 'dark' ? LogoDark : LogoWhite}
    alt="CarPlatform"
    className={className}
    style={style}
    {...rest}
  />
);
